// extracted by mini-css-extract-plugin
module.exports = {"note":"style_note__1_mk7","checkboxNote":"style_checkboxNote__Mhq_M","header":"style_header__nuvaZ"};